module.exports = __webpack_public_path__ + "static/img/subject_bg3.4ead0122.png";